module.exports = __webpack_public_path__ + "img/yjey-2.28975ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/yjey-2.jpg
// module id = uzVE
// module chunks = 0